import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  output
} from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { TranslocoDirective } from "@jsverse/transloco";
import { NotificationType } from "../../types/notifications.type";

@Component({
  selector: "app-snackbar",
  imports: [MatIcon, TranslocoDirective],
  templateUrl: "./snackbar.component.html",
  styleUrl: "./snackbar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarComponent {
  @HostBinding("class") get class(): string {
    switch (this.type()) {
      case NotificationType.Success:
        return "snackbar-success";
      case NotificationType.Info:
        return "snackbar-info";
      case NotificationType.Warning:
        return "snackbar-warning";
      case NotificationType.Error:
        return "snackbar-error";
    }
  }

  readonly type = input.required<NotificationType>();
  readonly message = input.required<string>();

  removeNotification = output<void>();

  removeNotificationEvent(): void {
    this.removeNotification.emit();
  }
}
